export const LOGIN = "LOGIN";
export const LOGOUT = "LOGOUT";
export const CHECK_ORGA_PROFILE = "CHECK_ORGA_PROFILE";
export const GET_PROFILE = "GET_PROFILE";
export const AUTOMATIC_LOGOUT = "AUTOMATIC_LOGOUT";
export const AUTOMATIC_LOGOUT_CLOSE = "AUTOMATIC_LOGOUT_CLOSE";
export const GOOGLE_SIGNUP = "GOOGLE_SIGNUP";
export const SET_AUTH_DIALOG = "SET_AUTH_DIALOG"
